import { Injectable } from '@angular/core'
import { WorkType } from '@awork/features/task/models/work-type.model'
import type { Task } from '@awork/features/task/models/task.model'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'
import { Subject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class WorkTypeStore extends EntitySignalStore<WorkType> {
  readonly taskWorkTypeSynced = new Subject<Task>()
  readonly resetCompleted = new Subject<void>()

  constructor() {
    super({ name: 'workType', entityConstructor: workType => new WorkType(workType) })
  }

  /**
   * Refreshes cached work type details from an external task without changing lookup-owned project choices.
   * Types absent from the lookup remain on the task for display.
   * @param {Task} task - The external task with its current work type details.
   */
  syncWorkTypeFromTask(task: Task): void {
    if (!task.project?.isExternal || !task.typeOfWork) {
      return
    }

    const workType = task.typeOfWork

    this.update(
      workType.id,
      storedWorkType => new WorkType({ ...workType, externalProjectIds: storedWorkType.externalProjectIds })
    )
    this.taskWorkTypeSynced.next(task)
  }

  /**
   * Resets work types and the task lookup history when the workspace changes.
   * @param {string} [action='workType: reset'] - The store reset action.
   */
  override reset(action = 'workType: reset'): void {
    super.reset(action)
    this.resetCompleted.next()
  }
}
